import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { Row, Col, Button, Label } from "reactstrap";
import {
  handleAddFilter,
  handleCleanFilter,
} from "redux/TaxAnalysis/productsSearch";
import { TextField, Select, Form } from "components/Form";
import { LIMIT_ROWS_OPTIONS } from "constants/Types/documentosFiscas.types";

export const FilterAdvanced = () => {
  const { filters } = useSelector(state => state.taxAnalysisProductsFilter);
  const dispatch = useDispatch();

  const { control, handleSubmit, reset, getValues } = useForm({
    defaultValues: { product_name: "", id: "", limit: null },
  });

  const onFilter = data => {
    for (const key in data) if (!data[key]) delete data[key];

    if (data?.id) {
      data.id = data.id
        .split(",")
        .map(value => value.trim())
        .filter(Boolean);
    }

    dispatch(
      handleAddFilter({
        ...data,
        limit: data?.limit?.value || filters?.limit,
      }),
    );
  };

  const handleClear = () => {
    dispatch(handleCleanFilter({ limit: filters?.limit }));
    reset({ ...getValues(), product_name: "", id: "" });
  };

  return (
    <Form onSubmit={handleSubmit(onFilter)}>
      <Row>
        <Col md="4">
          <Label>Produto</Label>
          <TextField name="product_name" control={control} />
        </Col>
        <Col md="4">
          <Label>Chave ou Número da Nota Fiscal</Label>
          <TextField name="id" control={control} />
        </Col>
        <Col md="2">
          <Label>Linhas</Label>
          <Select
            name="limit"
            control={control}
            options={LIMIT_ROWS_OPTIONS}
            placeholder="10"
          />
        </Col>
      </Row>
      <div className="d-flex gap-1 mt-1">
        <Button color="primary">Filtrar</Button>
        <Button color="danger" onClick={handleClear}>
          Limpar
        </Button>
      </div>
    </Form>
  );
};
